
import * as React from 'react';
import { BaseComponent, BaseComponentState, BaseComponentProps } from '../base/BaseComponent'; 
import Slider from 'react-slick';
import { newI18n } from './Const'; 
export interface InThePressProps extends BaseComponentProps {

}
export interface InThePressState extends BaseComponentState {
    press: any[];
}
export class InThePress extends BaseComponent<InThePressProps, InThePressState> {
    translation = {
        Title: newI18n("INTHEPTESS.Title", "In The Press"),
        SubTitle: newI18n("INTHEPTESS.SubTitle", "")
    };
    constructor(props: InThePressProps) {
        super(props);
        this.state = {
            press: []
        };
    }
    componentDidMount() {
        this.getData();
    }
    getData = () => {
        let press: any[] = [
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/abc-radio-australia.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/abc.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/ask.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/australian-business-review.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/big-spring-herald.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/bing-news.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/cbs-nes.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/cnn.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/daily-herald.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/daily-media-press-group.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/daily-times.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/fox-nes.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/google-news.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/karn-news-radio.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/marketplaces.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/nbc.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/pilot-news.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/sbs.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/startribun.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/street-insider.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/the-evening.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/the-morning-news.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/the-post-and-mail.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/travel-industry-today.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/tripadvisor.jpg", url: "https://www.tripadvisor.com/Attraction_Review-g303952-d13993230-Reviews-Bali_Tours_And_More-Kintamani_Bangli_Bali.html" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/wall-street-select.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/warl.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/wnd.jpg", url: "" },
            { imgPath: "https://storage.googleapis.com/bali-hotel-images/press/yahoo.jpg", url: "" },
        ];
        this.setState({ press });
    }
    render() {
        let settings: any = {
            dots: false,
            infinite: true,
            speed: 3000,
            slidesToShow: 6,
            slidesToScroll: 3,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
            ]
        };

        let inthepress: any[] = [];
        let loop = 0;
        for (let t of this.state.press) {
            let key = `inthePress${loop}`;
            if (  t.url !== "") {
                inthepress.push(
                    <a key={key} href={t.url} target="_blank">
                        <img src={t.imgPath} width="100%" />
                    </a>
                );
            } else {
                inthepress.push (<img  key={key}  src={t.imgPath} width="100%" />);
            }

        }

        return (
            <section className="container-fluid container-fullw bg-white" >
                <div className="container">
                    <div className="">
                        <div className="col-md-12">
                            <h2 className="text-center" > {this.translation.Title}</h2>
                            <hr />
                            <h4 className="text-center" > {this.translation.SubTitle}</h4>
                            <div className="row testimonial-container center">
                                <div data-appears-group-delay="0" data-appears-delay-increase="200">
                                    <div>
                                        <Slider {...settings}>
                                            {inthepress}
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/InThePress.tsx